import React, { useState, useEffect } from "react";
import { AppBar, Tabs, Tab, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { Hostage, ApiResponse, UserTab } from "../types";
import UserHeader from "./UserHeader";
import UserFeed from "./UserFeed";
import UserEvents from "./UserEvents";
import UserLetters from "./UserLetters";
import HostageList from "../Hostage/HostageList";
import feedIcon from "../../icons/feed.svg";
import eventsIcon from "../../icons/events.svg";
import hostagesIcon from "../../icons/hostages.svg";
import LettersIcon from "../../icons/letters.svg";
import "../../style/UserHome.css";
import UserHomeBanner from "./UserHomeBanner";
import LandingPage from "../LandingPage";

const UserHome = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { user, fetchUser, selectedTab, setSelectedTab } = useUser()!; // Add ! to assert that context is defined
  const [userHostages, setUserHostages] = useState<Hostage[]>([]);
  const [allHostages, setAllHostages] = useState<Hostage[]>([]);

  const fetchHostages = async () => {
    try {
      const response = await fetch("/api/hostage", {
        method: "GET",
        credentials: "include",
      });
      const res = (await response.json()) as ApiResponse;
      setAllHostages(res.items);

      const updatedUser = await fetchUser();
      const userHostages = res.items.filter((x) => updatedUser?.supported_hostages.includes(x.id));
      setUserHostages(userHostages);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchHostages();
    console.log("fetching...");
  }, [location]);

  const handleChange = (event: React.SyntheticEvent, newTab: UserTab) => {
    setSelectedTab(newTab);
  };

  return (
    <Box>
      <UserHeader userHostages={userHostages} setTabValue={setSelectedTab} />
      <UserHomeBanner />
      <AppBar
        position="sticky"
        sx={{
          top: 74,
          zIndex: 1100,
          boxShadow: "none",
        }}
      >
        <Tabs
          className="userTabs"
          value={selectedTab}
          onChange={handleChange}
          sx={{  
            ".MuiTabs-flexContainer": {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            ".MuiTabs-indicator": {
              height: "4px",
              backgroundColor: "#FF395D", // Change indicator to red
            },
            ".Mui-selected": { 
              color: "black !important", // Selected tab text color
              borderBottom: "4px solid #FF395D", // Red bottom border for selected tab
            },
          }}
        >
          <Tab
            label={t("userHome.tabs.feed")}
            icon={<img src={feedIcon} alt="Feed" />}
            value="Feed"
          />
          <Tab
            label={t("userHome.tabs.events")}
            icon={<img src={eventsIcon} alt="Events" />}
            value="Activities"
          />
          <Tab
            label={t("userHome.tabs.hostages")}
            icon={<img src={hostagesIcon} alt="Hostages" />}
            value="Hostages"
          />
        </Tabs>
      </AppBar>
      <Box sx={{ backgroundColor: "#f6f6f6" }}>
        {selectedTab === "Feed" && <UserFeed allHostages={allHostages} />}
        {selectedTab === "Activities" && <UserEvents allHostages={allHostages} />}
        {selectedTab === "Hostages" && <HostageList hostages={allHostages} />}
      </Box>
    </Box>
  );
};

export default UserHome;
